module.exports = __webpack_public_path__ + "images/emojis-in-domain-names-a-security-risk-for-everyone-1600w.webp";